import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { usePlusArticlePopup } from "scmp-app/components/plus/article-popup/hooks";
import type { featuredOpinionBlockItemContent$key } from "scmp-app/queries/__generated__/featuredOpinionBlockItemContent.graphql";

import { StyledContentItemPlusOpinion } from "./styles";

export type Props = {
  reference: featuredOpinionBlockItemContent$key;
};

export const FeaturedOpinionBlockItem: FunctionComponent<Props> = ({ reference }) => {
  const content = useFragment(
    graphql`
      fragment featuredOpinionBlockItemContent on Content {
        ...hooksPlusArticleLinkHandlerArticle
        ...plusOpinionContentItemContent
        ...plusPrimaryContentItemContent
        ...plusSecondaryContentItemContent
      }
    `,
    reference,
  );

  const { handleOpen } = usePlusArticlePopup();

  return (
    <StyledContentItemPlusOpinion
      reference={content}
      withAuthor
      onClick={() => handleOpen(content, { pageType: "homepage", widgetName: "featured_opinion" })}
    />
  );
};

FeaturedOpinionBlockItem.displayName = "FeaturedOpinionBlockItem";
